import { atom } from 'jotai'

import { TQrContent, TQrData } from '@/generator/shared'

import {
	TABLE_ACTION_TYPE,
	TABLE_ROW_ACTION_TYPE,
} from './TableActions/Actions/actionOptions'
import { TRow, TTable } from './tableTypes'

export const qrItemState = atom<TQrData | null>(null)

export const enableQrPasswordDialogAtom = atom<boolean>(false)

export const disableQrPasswordRequestAtom = atom<TQrData | null>(null)

export const confirmationDialogTypeState = atom<TABLE_ACTION_TYPE | null>(null)

export const mobileTableRowActionDialogAtom = atom<boolean>(false)
export const mobileTableRowActionDialogTypeAtom =
	atom<TABLE_ROW_ACTION_TYPE | null>(null)

export const desktopTableRowActionPopoverAtom = atom<boolean>(false)
export const desktopTableRowActionPopoverTypeAtom =
	atom<TABLE_ROW_ACTION_TYPE | null>(null)

export const desktopTableRowPopoverStateAtom = atom<{
	buttonRef: React.RefObject<HTMLButtonElement | null> | null
}>({
	buttonRef: null,
})

export const shareQrDialogAtom = atom(false)

export const shareQrLinkAtom = atom<string>('')

export const scanQrDialogAtom = atom(false)
export const scanQrDialogDataAtom = atom<{
	id: string
	uri: string
	previewSvgString: string
	disabled: boolean
	content: TQrContent
} | null>(null)

export const editQrNameDialogAtom = atom<boolean>(false)
export const editQrNameDialogAtomData = atom<{
	row: TRow
	name: string
	table: TTable
} | null>(null)

export const editQrUrlDialogAtom = atom<boolean>(false)
export const editQrUrlDialogDataAtom = atom<{
	row: TRow
	table: TTable
	url: string
} | null>(null)

export const bulkSelectedQrsState = atom<TQrData[]>([])
